import { FC } from 'react'
import Image from 'next/image'

import LikeShare from 'components/parts/like-share/like-share'

import { STATIC_URL } from 'constants/data'
import { IMaterial } from 'constants/types/webinar.types'
import { originShare } from 'utils/analytics/other/share_material/share_material'

import styles from './webinar-header.module.scss'

const imgData = {
  src: `${STATIC_URL}/webinar/nmo-icon.png`,
  width: 18,
  height: 18,
}

const WebinarHeader: FC<IMaterial> = ({ name, points }: IMaterial) => {
  return (
    <div className={styles.webinarHeader}>
      <div className={styles.themesContainer}>
        <div className={styles.theme}>Онлайн</div>
        {!!points && (
          <div className={styles.theme}>
            <Image {...imgData} alt="nmo" />
            НМО
          </div>
        )}
      </div>
      <div className={styles.titleContainer}>
        <h1 className={styles.title}>{name}</h1>
      </div>
      <div>
        <LikeShare
          AData={{ origin: originShare.WEBINAR_FUTURE }}
          menuModificator={styles.menuModifactor}
          noLike
        />
      </div>
    </div>
  )
}

export default WebinarHeader
